import { render, staticRenderFns } from "./jobfairUnits.vue?vue&type=template&id=526f923e&scoped=true"
import script from "./jobfairUnits.vue?vue&type=script&lang=js"
export * from "./jobfairUnits.vue?vue&type=script&lang=js"
import style0 from "./jobfairUnits.vue?vue&type=style&index=0&id=526f923e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f923e",
  null
  
)

export default component.exports